// extracted by mini-css-extract-plugin
export var discard = "_2b-4";
export var muiTooltipTooltip = "_2b-6";
export var notificationBar = "_2b-3";
export var notificationContainer = "_2b-2";
export var saveButtonHoverSlotWrapper = "_2b-5";
export var show = "_2b-1";
export var spacer = "_2b-0";